import React, { useEffect, useState } from 'react';
import { useAuth } from '../../commons/Auth';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import './ScheduledReporting.scss';
import './TabsScheduledReporting.scss';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import BurgerMenu from '../../commons/BurgerMenu';
import variables from '../../variables';
import { ReactComponent as IcnDocument } from '../../images/icn_document.svg';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';
import axios from 'axios';
import Header from '../../commons/Header';
import ExtraInvoiceInvoices from './ExtraInvoiceInvoices';
import PanoramicaInvoiceInsurances from './PanoramicaInvoiceInsurances';
import ExtraIafs from './ExtraIafs';
import PanoramicaIafs from './PanoramicaIafs';
import NetworkIafs from './NetworkIafs';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function ScheduledReporting({ history, location, match = {} }) {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('SCHEDULED_REPORTING');
  const { showLoading, hideLoading } = useLoading();

  const { params: { id } = {}, url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const [queueJobRequests, setQueueJobRequests] = useState([]);
  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    year: NumberParam,
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    status: withDefault(StringParam),
    type: withDefault(StringParam, 'EXTRA_INVOICE_INVOICES'),
    business: withDefault(StringParam, 'EXTRA'),
  });

  const { year, type, business, limit, offset, status } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.year && queryDiff.year !== year) ||
      (year && queryDiff.year === '') ||
      (queryDiff.type && queryDiff.type !== type) ||
      (type && queryDiff.type === '') ||
      (queryDiff.business && queryDiff.business !== business) ||
      (business && queryDiff.business === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0;
    }

    setQuery(queryDiff);
  }

  const fetchQueueJobRequests = async (query) => {
    showLoading();
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/queueJobRequests`,
      {
        headers: { Authorization: newToken },
        params: {
          offset: query.offset,
          limit: query.limit,
          year: query.year,
          queueJobStatus: query.status,
          type: query.type,
        },
      }
    );
    hideLoading();
    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    setQueueJobRequests(response.data || []);
    setTotal(Number(response.headers['x-total-count']));
  };

  useEffect(() => {
    fetchQueueJobRequests(query);
  }, [year, status, type, business, limit, offset]);

  if (pathname === url) {
    return <Redirect to={`${url}/extra-invoices-invoice`} />;
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:SCHEDULED_REPORTING')}
            icon={<IcnDocument fill={variables.white} />}
          />
        </section>

        <section>
          <div className="m-tb-20">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}?type=EXTRA_INVOICE_INVOICES&business=EXTRA`}
                  className={classNames({
                    active: tab === 'extra-invoices-invoice',
                  })}
                >
                  {t('SCHEDULED_REPORTING_EXTRA_INVOICE_INVOICES')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/panoramica-invoices-insurances?type=PANORAMICA_INVOICE_INSURANCES&business=PANORAMICA`}
                  className={classNames({
                    active: tab === 'panoramica-invoices-insurances',
                  })}
                >
                  {t('SCHEDULED_REPORTING_PANORAMICA_INVOICE_INSURANCES')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/extra-iafs?type=EXTRA_IAFS&business=EXTRA`}
                  className={classNames({
                    active: tab === 'extra-iafs',
                  })}
                >
                  {t('SCHEDULED_REPORTING_EXTRA_IAFS')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/panoramica-iafs?type=PANORAMICA_IAFS&business=PANORAMICA`}
                  className={classNames({
                    active: tab === 'panoramica-iafs',
                  })}
                >
                  {t('SCHEDULED_REPORTING_PANORAMICA_IAFS')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/network-iafs?type=NETWORK_IAFS&business=NETWORK`}
                  className={classNames({
                    active: tab === 'network-iafs',
                  })}
                >
                  {t('SCHEDULED_REPORTING_NETWORK_IAFS')}
                </NavLink>
              </NavItem>
            </Nav>

            <Switch>
              <Route
                path={`${match.url}/extra-invoices-invoice`}
                component={(props) => (
                  <ExtraInvoiceInvoices
                    queueJobRequests={queueJobRequests}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/panoramica-invoices-insurances`}
                component={(props) => (
                  <PanoramicaInvoiceInsurances
                    queueJobRequests={queueJobRequests}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/extra-iafs`}
                component={(props) => (
                  <ExtraIafs
                    queueJobRequests={queueJobRequests}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/panoramica-iafs`}
                component={(props) => (
                  <PanoramicaIafs
                    queueJobRequests={queueJobRequests}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />

              <Route
                path={`${match.url}/network-iafs`}
                component={(props) => (
                  <NetworkIafs
                    queueJobRequests={queueJobRequests}
                    query={query}
                    total={total}
                    onFilter={onFilter}
                    {...props}
                  />
                )}
              />
            </Switch>
          </div>
        </section>
      </div>
    </div>
  );
}

export default withRouter(ScheduledReporting);
